"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2759],{

/***/ 32759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ side_by_side_with_paragraphs_paragraph_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js + 1 modules
var side_by_side_text_and_asset = __webpack_require__(25641);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-with-paragraphs-paragraph/side-by-side-with-paragraphs-paragraph-component.scss.js


var BORDER_RADIUS = 16;
var BORDER_RADIUS_STRING = "".concat(BORDER_RADIUS, "px");
var StyledSideBySideWithParagraphsParagraphComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "epwmcfc0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.side-by-side-text-and-asset{border-radius:", BORDER_RADIUS_STRING, ";.side-by-side-content{border-radius:", BORDER_RADIUS_STRING, ";padding:50px;.full-paragraph-component-wrapper{height:100%;.left-section-wrapper{display:flex;justify-content:space-between;flex-direction:column;height:100%;}}}}.image-wrapper{display:flex;flex-direction:column;gap:50px;.right-section-paragraph-wrapper{width:100%;}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.side-by-side-text-and-asset{.side-by-side-content{height:fit-content;}}}");

// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-with-paragraphs-paragraph/default-props.js

/* harmony default export */ var default_props = ({
    background: {
        width: "100%",
        backgroundImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/enterprise/forrester_bg.png"
        }
    },
    primaryParagraph: {
        topic: {
            image: {
                src: "/Generator_featured images/enterprise/forrester_logo.png",
                height: "20px"
            }
        },
        title: "Transformation by the numbers",
        body: "Deep dive into The Total Economic Impact™ of monday.com Work OS for Motorola over three years.",
        buttonConfig: {
            buttonType: "Secondary",
            buttonText: "Get the full report",
            url: "https://monday.com/lp/forrester-tei-report-motorola",
            isOpenLinkInNewTab: true
        }
    },
    leftSectionBottomText: "",
    paragraphs: [
        {
            fullParagraph: {
                topic: {},
                title: "346%",
                body: "return on investment (ROI) over three years",
                paragraphVerticalColoredLineColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                titleColor: color_consts.WORK_OS_IRIS_COLOR_NAME
            }
        },
        {
            fullParagraph: {
                topic: {},
                title: "$127K",
                body: "increase in creative team productivity",
                paragraphVerticalColoredLineColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                titleColor: color_consts.WORK_OS_IRIS_COLOR_NAME
            }
        },
        {
            fullParagraph: {
                topic: {},
                title: "$279K",
                body: "net present value (NPV) over three years",
                paragraphVerticalColoredLineColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                titleColor: color_consts.WORK_OS_IRIS_COLOR_NAME
            }
        }
    ]
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-with-paragraphs-paragraph/side-by-side-with-paragraphs-paragraph-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var SideBySideWithParagraphsParagraphComponent = function(props) {
    var primaryParagraph = props.primaryParagraph, leftSectionBottomText = props.leftSectionBottomText, leftSectionBottomTextColor = props.leftSectionBottomTextColor, leftSectionParagraphAdvancedProps = props.leftSectionParagraphAdvancedProps, rightSectionParagraphAdvancedProps = props.rightSectionParagraphAdvancedProps, paragraphs = props.paragraphs, restProps = _object_without_properties(props, [
        "primaryParagraph",
        "leftSectionBottomText",
        "leftSectionBottomTextColor",
        "leftSectionParagraphAdvancedProps",
        "rightSectionParagraphAdvancedProps",
        "paragraphs"
    ]);
    var rightSectionParagraphs = function() {
        return paragraphs.map(function(paragraph, index) {
            var fullParagraph = paragraph.fullParagraph;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "right-section-paragraph-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, fullParagraph, rightSectionParagraphAdvancedProps))
            });
        });
    };
    var leftSection = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "left-section-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "full-paragraph-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, primaryParagraph, leftSectionParagraphAdvancedProps))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "paragraph-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        body: leftSectionBottomText,
                        bodyColor: leftSectionBottomTextColor,
                        textSize: sizes.SM
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideWithParagraphsParagraphComponent, {
        className: "side-by-side-with-paragraphs-paragraph-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, _object_spread({
            replaceAssetComponent: rightSectionParagraphs,
            replaceTextComponent: leftSection
        }, restProps))
    });
};
SideBySideWithParagraphsParagraphComponent.defaultProps = default_props;
/* harmony default export */ var side_by_side_with_paragraphs_paragraph_component = (SideBySideWithParagraphsParagraphComponent);


/***/ })

}]);